import React, { useContext, useState } from 'react';
import {
  Modal,
  Divider,
  Form,
  Row,
  Col,
  InputNumber,
  notification,
} from 'antd';

import GetLabel from 'DisplayFramework/components/GetLabel';
import { useForm } from 'antd/lib/form/Form';
import FormInput from 'components/FormInput';
import { shouldUpdateCompare } from 'utils/utils2';
import Button from 'components/Button';
import { isNil } from 'lodash';

import { calculateAssetCatalogFutureValue } from 'services/assetconfig';

import AssetDVuseScheduleModal from 'pages/Asset/components/AssetUse/AssetFVUseContextSchModal';
import AssetFVScheduleModal from 'pages/Asset/components/AssetUse/AssetFVScheduleModal';
import InputCurrency from 'components/InputCurrency';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { AuthContext } from 'components/Auth/Auth';
import IPaymentschedule from 'icons/IPaymentschedule';

type SimulateModalProps = {
  visible: boolean;
  onClose: () => void;
  assetnetamount: any;
  parcontexid: number;
  currcode: any;
};
const SimulateModal = (props: SimulateModalProps) => {
  const { isInspect } = useContext(AuthContext);
  const {
    visible,
    onClose,
    assetnetamount: assetnetamountprop,
    parcontexid,
    currcode,
  } = props;

  const initialValues = {
    assetnetamount: !isNil(assetnetamountprop) ? assetnetamountprop : '',
    duration: '' as any,
  };
  const [isLoading, setisLoading] = useState(false);
  const [form] = useForm();

  const calculate = async (values: any) => {
    setisLoading(true);

    await calculateAssetCatalogFutureValue({
      request: {
        assetnetamount: values.assetnetamount,
        parcontextid: parcontexid,
        assetid: '' as any,
        contextid: '' as any,
        duration: values.duration,
        mode: 'INIT',
        newmarketvalue: '' as any,
        newvaluedate: '' as any,
        proctaskid: '' as any,
        useCondition: [] as any,
        paymentSchedule: [] as any,
      },
    })
      .then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
          form.setFieldsValue({ assetFutureValue: res });
          setisLoading(false);
        }
      })
      .catch((res) => {
        form.setFieldsValue({ assetFutureValue: res });
        notification.error({ message: res.message });
        setisLoading(false);
      });
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      width={600}
      title={<GetLabel label="SimulFV" />}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        labelCol={{ span: 24 }}
        onFinishFailed={onFinishFailed}
        onFinish={calculate}
      >
        <Row gutter={32}>
          <FormInput
            col
            xs={24}
            md={12}
            rules={[{ required: true }]}
            name="assetnetamount"
          >
            <InputCurrency currcode={currcode ?? localStorage.getItem('currcode') ?? ''} />
          </FormInput>
          <FormInput
            col
            xs={24}
            md={12}
            rules={[{ required: true }]}
            name="duration"
          >
            <InputNumber />
          </FormInput>
        </Row>
        <Row justify="center">
          <Col span={12} style={{ marginTop: '1rem' }}>
            <Form.Item shouldUpdate={shouldUpdateCompare('context')} noStyle>
              {({ getFieldValue }) => {
                return (
                  <Button
                    // disabled={isNil(getFieldValue('context'))}
                    loading={isLoading}
                    comcode="calculate"
                    type="primary"
                    onClick={() => form.submit()}
                  />
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Divider>Calculation Result</Divider>
        <Row gutter={32}>
          <Col span={8}>
            {form.getFieldValue('assetFutureValue')?.code === '200'
              ? form.getFieldValue('assetFutureValue')?.message
              : 'Please enter simulation values'}
          </Col>
          <Col span={8}>
            {form.getFieldValue('assetFutureValue')?.code === '200' && (
              <AssetDVuseScheduleModal
                AssetfvcontextuseResponse={
                  form.getFieldValue('assetFutureValue')?.data?.fvContextUse
                }
                controller={<Button comcode="ListFVContextUse" />}
              />
            )}
          </Col>
          <Col span={8}>
            {form.getFieldValue('assetFutureValue')?.code === '200' && (
              <AssetFVScheduleModal
                assetfvschedule={
                  form.getFieldValue('assetFutureValue')?.data?.fvSchedule
                }
                controller={
                  <Button
                    comcode="FVScheduleButton"
                    style={{
                      height: 50,
                      width: '100%',
                    }}
                    icon={<IPaymentschedule color="blue" height="17px" width="16px"/>}
                  />
                }
              />
            )}
          </Col>
        </Row>
        <Divider />
        <Row gutter={32}>
          <Button comcode="Cancel" onClick={onClose} />
        </Row>
      </Form>
    </Modal>
  );
};

export default SimulateModal;
